import { defineStore } from 'pinia';
import { ref } from 'vue';
import activitiesAPI from '@/api/activities';
import type { Activity } from '@/types/Activity';

export const useActivitiesStore = defineStore('activities', () => {
  const activities = ref<Activity[]>([]);
  
  const fetchActivities = async (params: any): Promise<{ data: Activity[]; total: number }> => {
    try {
      const response = await activitiesAPI.getActivities(params);
      const data: Activity[] = response.data.data;
      const total = response.data.meta.total;
      activities.value = data;
      return { data, total };
    } catch (error) {
      console.error('Error fetching activity s:', error);
      throw error;
    }
  };

  const fetchActivityById = async (id: number) => {
    try {
      const response = await activitiesAPI.getActivityById(id);
      return response.data.data as Activity;
    } catch (error) {
      console.error(`Error fetching activity  with ID ${id}:`, error);
    }
  };

  const createActivity = async (activityData: Partial<Activity>) => {
    try {
      const response = await activitiesAPI.createActivity(activityData);
      activities.value.push(response.data.data as Activity);
      return response.data;
    } catch (error) {
      console.error('Error creating activity :', error);
    }
  };

  const updateActivity = async (id: number, activityData: Partial<Activity>) => {
    try {
      const response = await activitiesAPI.updateActivity(id, activityData);
      const updated = response.data.data as Activity;
      const index = activities.value.findIndex((c:any) => c.id === id);
      if (index !== -1) {
        activities.value[index] = updated;
      }
      return response.data;
    } catch (error) {
      console.error(`Error updating activity  with ID ${id}:`, error);
    }
  };

  const deleteActivity = async (id: number) => {
    try {
      await activitiesAPI.deleteActivity(id);
      activities.value = activities.value.filter((c) => c.id !== id);
    } catch (error) {
      console.error(`Error deleting activity  with ID ${id}:`, error);
    }
  };

  return {
    activities,
    fetchActivities,
    fetchActivityById,
    createActivity,
    updateActivity,
    deleteActivity,
  };
});
